(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["omega-map"] && !Shopify.designMode) return;
  try {
    
(function(){
  const P=[
    {s:"Steelhead Trout",f:"Hudson Valley",oz:6,src:"Edacious",n:3,avg:{e:565,d:1563,a:2432,t:4560},last:{e:476,d:1509,a:2666,t:4651},
     tests:[{c:"F8NYY",e:700,d:1681,a:2478,t:4859},{c:"BX2MD",e:520,d:1499,a:2153,t:4171},{c:"WH58L",e:476,d:1509,a:2666,t:4651}]},
    {s:"King Salmon",f:"Ora King",oz:7.5,src:"Edacious",n:2,avg:{e:806,d:1618,a:1823,t:4247},last:{e:818,d:1717,a:1905,t:4440},
     tests:[{c:"EMVTA",e:795,d:1518,a:1741,t:4054},{c:"J931J",e:818,d:1717,a:1905,t:4440}]},
    {s:"King Salmon",f:"Mt Cook",oz:7.5,src:"Edacious",n:2,avg:{e:687,d:1297,a:1718,t:3702},last:{e:609,d:1258,a:1438,t:3305},
     tests:[{c:"B1SX1",e:765,d:1336,a:1998,t:4099},{c:"VM87T",e:609,d:1258,a:1438,t:3305}]},
    {s:"Atlantic Salmon",f:"Bakkafrost",oz:6,src:"Edacious",n:6,avg:{e:709,d:1254,a:1430,t:3393},last:{e:685,d:1234,a:1270,t:3189},
     tests:[{c:"WBQZS",e:779,d:1277,a:1788,t:3844},{c:"FI7JG",e:558,d:1066,a:976,t:2600},{c:"G3RNX",e:670,d:1166,a:1365,t:3202},{c:"NPQ21",e:768,d:1353,a:1480,t:3601},{c:"QCDSN",e:793,d:1430,a:1699,t:3922},{c:"UE6K3",e:685,d:1234,a:1270,t:3189}]},
    {s:"Steelhead Trout",f:"Caleta Bay",oz:6,src:"Edacious+LL",n:5,avg:{e:466,d:1030,a:1895,t:3391},last:{e:1028,d:2305,a:4356,t:7689},
     tests:[{c:"CR3YP",e:441,d:1033,a:2406,t:3880},{c:"VH3MB",e:377,d:813,a:1862,t:3052},{c:"YV55W",e:363,d:814,a:1717,t:2894},{c:"21148",e:255,d:629,a:0,t:884},{c:"24241",e:1028,d:2305,a:4356,t:7689}]},
    {s:"King Salmon",f:"Regal",oz:7.5,src:"Light Labs",n:1,avg:{e:469,d:1276,a:1699,t:3444},last:{e:469,d:1276,a:1699,t:3444},
     tests:[{c:"16691",e:469,d:1276,a:1699,t:3444}]},
    {s:"Osetra Caviar",f:"Marshallberg",oz:1,src:"Light Labs",n:1,avg:{e:847,d:2127,a:275,t:3249},last:{e:847,d:2127,a:275,t:3249},
     tests:[{c:"9769",e:847,d:2127,a:275,t:3249}]},
    {s:"Branzino",f:"Esteros Lubimar",oz:5,src:"Edacious",n:6,avg:{e:457,d:900,a:1325,t:2682},last:{e:472,d:921,a:1423,t:2817},
     tests:[{c:"X7JKU",e:527,d:931,a:1753,t:3212},{c:"XLQVW",e:517,d:1011,a:1401,t:2930},{c:"US8EG",e:403,d:892,a:945,t:2241},{c:"6MNW9",e:157,d:400,a:469,t:1025},{c:"7JB6N",e:668,d:1242,a:1956,t:3866},{c:"N3R8P",e:472,d:921,a:1423,t:2817}]},
    {s:"Sea Bream",f:"Esteros Lubimar",oz:5,src:"Edacious",n:6,avg:{e:333,d:854,a:968,t:2155},last:{e:368,d:840,a:999,t:2207},
     tests:[{c:"T5ZA9",e:389,d:974,a:1091,t:2455},{c:"VBTTQ",e:455,d:1084,a:1395,t:2933},{c:"QY119",e:347,d:916,a:937,t:2200},{c:"CAZIS",e:174,d:562,a:678,t:1414},{c:"E1JBA",e:265,d:749,a:710,t:1724},{c:"LLZKQ",e:368,d:840,a:999,t:2207}]},
    {s:"Salmon Roe Caviar",f:"Yarra Valley",oz:1,src:"Light Labs",n:1,avg:{e:874,d:3899,a:242,t:5015},last:{e:874,d:3899,a:242,t:5015},
     tests:[{c:"22491",e:874,d:3899,a:242,t:5015}]},
    {s:"Rainbow Trout",f:"McFarland Springs",oz:6,src:"Light Labs",n:1,avg:{e:246,d:847,a:981,t:2074},last:{e:246,d:847,a:981,t:2074},
     tests:[{c:"10851",e:246,d:847,a:981,t:2074}]},
    {s:"Yellowtail",f:"The Kingfish Co.",oz:6,src:"Light Labs",n:1,avg:{e:427,d:1250,a:179,t:1856},last:{e:427,d:1250,a:179,t:1856},
     tests:[{c:"3958",e:427,d:1250,a:179,t:1856}]},
    {s:"Rainbow Trout",f:"Smoke in Chimneys",oz:6,src:"Light Labs",n:1,avg:{e:146,d:687,a:56,t:889},last:{e:146,d:687,a:56,t:889},
     tests:[{c:"3954",e:146,d:687,a:56,t:889}]},
    {s:"Barramundi",f:"Australis",oz:6,src:"Light Labs",n:1,avg:{e:71,d:303,a:46,t:420},last:{e:71,d:303,a:46,t:420},
     tests:[{c:"3934",e:71,d:303,a:46,t:420}]},
    {s:"Black Tiger Shrimp",f:"Tarakan",oz:4,src:"Light Labs",n:1,avg:{e:82,d:80,a:14,t:176},last:{e:82,d:80,a:14,t:176},
     tests:[{c:"9762",e:82,d:80,a:14,t:176}]},
    {s:"Peruvian Scallops",f:"Seacorp",oz:4,src:"Light Labs",n:1,avg:{e:35,d:31,a:0,t:66},last:{e:35,d:31,a:0,t:66},
     tests:[{c:"11337",e:35,d:31,a:0,t:66}]}
  ];

  const OZ_TO_G=28.3495;

  // ── Microplastics (EMSL via Light Labs) — attach result + test code to products ──
  // Only products with mp:'ND' here have been screened through the 6-polymer EMSL panel.
  // This is a separate assay from the Edacious fatty-acid panel — surfacing it here
  // so the customer-facing view reflects EVERY test performed.
  //
  // Panel detail: 6 polymers, LOD = 1 microparticle each. "ND" means literally zero
  // detected against that 1-microparticle threshold, not "below an unknown floor."
  const MP_PANEL = {
    lod: 1,
    unit: 'microparticles',
    lab: 'EMSL Analytical (via Light Labs)',
    method: 'FTIR / optical microscopy',
    polymers: [
      {a:'HDPE', n:'High-Density Polyethylene',  s:'milk jugs, bottle caps'},
      {a:'LDPE', n:'Low-Density Polyethylene',   s:'plastic bags, films'},
      {a:'PET',  n:'Polyethylene Terephthalate', s:'water bottles, fishing line'},
      {a:'PP',   n:'Polypropylene',              s:'caps, ropes, fishing nets'},
      {a:'PS',   n:'Polystyrene',                s:'foam packaging, pen floats'},
      {a:'PVC',  n:'Polyvinyl Chloride',         s:'pipes, liners'}
    ]
  };
  const MP_BY_FARM = {
    "Hudson Valley":      {r:'ND',c:'21516'},
    "Ora King":           {r:'ND',c:'21518'},
    "Mt Cook":            {r:'ND',c:'21517'},
    "Bakkafrost":         {r:'ND',c:'21521'},
    "Regal":              {r:'ND',c:'21524'},
    "Marshallberg":       {r:'ND',c:'22503'},
    "Esteros Lubimar":    {r:'ND',c:'21525/21526'},
    "Yarra Valley":       {r:'ND',c:'21527'},
    "McFarland Springs":  {r:'ND',c:'22135'},
    "The Kingfish Co.":   {r:'ND',c:'21520'},
    "Smoke in Chimneys":  {r:'ND',c:'21519'},
    "Australis":          {r:'ND',c:'21514'},
    "Seacorp":            {r:'ND',c:'21523'}
  };
  P.forEach(p => { const m = MP_BY_FARM[p.f]; if (m) { p.mp = m.r; p.mpCode = m.c; } });

  let mode='average', basis='serving', openIdx=-1, view='chart', sortK='total', sortA=false;
  function g(p){return mode==='average'?p.avg:p.last;}
  // Scale a 6oz-standardized value to current basis
  function sc(v6,oz){
    if(basis==='100g') return Math.round(v6/(6*OZ_TO_G/100));
    return Math.round(v6*oz/6); // per Seatopia recommended serving
  }
  function gs(p){const r=g(p);return{e:sc(r.e,p.oz),d:sc(r.d,p.oz),a:sc(r.a,p.oz),t:sc(r.e,p.oz)+sc(r.d,p.oz)+sc(r.a,p.oz)};}

  function basisLabel(p){return basis==='100g'?'mg / 100g':'mg / '+p.oz+' oz';}
  function statLabel(){return basis==='100g'?'per 100g edible portion':'per Seatopia recommended serving';}

  function renderChart(){
    const sorted=[...P].sort((a,b)=>gs(b).t-gs(a).t);
    const mx=Math.max(...sorted.map(p=>gs(p).t));
    let tt=0; sorted.forEach(p=>tt+=p.n);
    const mpTested = sorted.filter(p=>p.mp).length;
    const mpND = sorted.filter(p=>p.mp==='ND').length;
    const mpStat = mpTested>0 ? ' · <strong>'+mpTested+'</strong> microplastics-screened (0 of '+(mpTested*6)+' polymers detected · LOD 1 microparticle)' : '';
    document.getElementById('om-stat').innerHTML='<strong>'+sorted.length+'</strong> products · <strong>'+tt+'</strong> tests'+mpStat+' · '+statLabel();

    let h='';
    sorted.forEach((p,i)=>{
      const d=gs(p);
      const bw=(d.t/mx)*68;
      const ep=d.t>0?(d.e/d.t*100):0;
      const dp=d.t>0?(d.d/d.t*100):0;
      const ap=Math.max(0,100-ep-dp);
      const eL=ep>12?'<span class="om-sl">EPA '+d.e.toLocaleString()+'</span>':'';
      const dL=dp>14?'<span class="om-sl">DHA '+d.d.toLocaleString()+'</span>':'';
      const aL=ap>14?'<span class="om-sl">ALA '+d.a.toLocaleString()+'</span>':'';
      const servInfo=basis==='100g'?'per 100g':p.oz+' oz serving';

      const mpBadge = p.mp ? '<span style="display:inline-block;background:#2e8b57;color:#fff;font-size:9px;font-weight:700;padding:1px 5px;border-radius:3px;margin-left:6px;letter-spacing:0.3px" title="0 of 6 polymers detected · LOD 1 microparticle · EMSL FTIR · Test #'+p.mpCode+'">0 / 6 MP</span>' : '';

      h+='<div class="om-row" onclick="omDet('+i+')">'
        +'<div class="om-lbl"><div class="om-sp">'+p.s+', '+p.f+mpBadge+'</div><div class="om-fm">'+servInfo+'</div></div>'
        +'<div class="om-bw"><div class="om-bar" style="width:'+bw+'%">'
        +'<div class="om-bar-epa" style="width:'+ep+'%">'+eL+'</div>'
        +'<div class="om-bar-dha" style="width:'+dp+'%">'+dL+'</div>'
        +'<div class="om-bar-ala" style="width:'+ap+'%">'+aL+'</div>'
        +'</div><div class="om-val">'+d.t.toLocaleString()+' mg</div></div>'
        +'<div class="om-ts"><strong>'+p.n+'</strong>test'+(p.n>1?'s':'')+'</div></div>';

      const ul=basisLabel(p);
      const polyChips = MP_PANEL.polymers.map(pp =>
        '<span style="display:inline-block;background:#fff;border:1px solid rgba(46,139,87,0.3);border-radius:3px;padding:1px 5px;margin:1px 3px 1px 0;font-size:10px" title="'+pp.n+' — '+pp.s+'"><strong style="color:#1f5f3f">'+pp.a+'</strong> <span style="color:#2e8b57;font-weight:700">ND</span></span>'
      ).join('');
      const mpLine = p.mp
        ? '<div style="margin-top:6px;padding:8px 10px;background:rgba(46,139,87,0.08);border-left:3px solid #2e8b57;border-radius:4px;font-size:11px;color:#1f5f3f">'
          +'<div style="font-weight:700;margin-bottom:3px">Microplastics: 0 microparticles detected <span style="font-weight:400;color:#555">· 0 of 6 polymers · LOD 1 microparticle</span></div>'
          +'<div style="margin:4px 0">'+polyChips+'</div>'
          +'<div style="font-size:10px;color:#555">EMSL FTIR / optical microscopy · Test #'+p.mpCode+' · Light Labs</div>'
          +'</div>'
        : '<div style="margin-top:6px;padding:6px 10px;background:rgba(0,0,0,0.03);border-left:3px solid #ccc;border-radius:4px;font-size:11px;color:#888;font-style:italic">Microplastics screening pending for this farm.</div>';
      h+='<div class="om-det" id="om-d-'+i+'"><div class="om-det-g">'
        +'<div class="om-det-b"><div class="lb epa">EPA</div><div class="nm">'+d.e.toLocaleString()+'</div><div class="un">'+ul+'</div></div>'
        +'<div class="om-det-b"><div class="lb dha">DHA</div><div class="nm">'+d.d.toLocaleString()+'</div><div class="un">'+ul+'</div></div>'
        +'<div class="om-det-b"><div class="lb ala">ALA</div><div class="nm">'+d.a.toLocaleString()+'</div><div class="un">'+ul+'</div></div>'
        +'</div><div class="om-det-m">'+p.n+' test'+(p.n>1?'s':'')+' · '+p.f+' · '+servInfo+' · '+(mode==='average'?'Average':'Last test')+'</div>'+mpLine+'</div>';
    });
    document.getElementById('om-chart').innerHTML=h;
  }

  function renderTable(){
    let rows=[];
    P.forEach(p=>{p.tests.forEach(t=>{
      rows.push({s:p.s,f:p.f,c:t.c,src:p.src,oz:p.oz,assay:'Fatty Acids',
        e:sc(t.e,p.oz),d:sc(t.d,p.oz),a:sc(t.a,p.oz),t:sc(t.e,p.oz)+sc(t.d,p.oz)+sc(t.a,p.oz),mp:null});
    });
    // Microplastics rows — one per product that has been MP-screened
    if (p.mp) rows.push({s:p.s,f:p.f,c:p.mpCode,src:'Light Labs (EMSL)',oz:p.oz,assay:'Microplastics',
      e:null,d:null,a:null,t:null,mp:p.mp});
    });
    rows.sort((a,b)=>{let va=a[sortK],vb=b[sortK];if(va==null)va=-Infinity;if(vb==null)vb=-Infinity;if(typeof va==='string'){va=va.toLowerCase();vb=vb.toLowerCase();}return sortA?(va<vb?-1:va>vb?1:0):(va>vb?-1:va<vb?1:0);});

    const uLbl=basis==='100g'?' (mg/100g)':' (mg/serving)';
    let h='<table class="om-tbl"><thead><tr>';
    [{k:'s',l:'Species'},{k:'f',l:'Farm'},{k:'c',l:'Sample'},{k:'src',l:'Lab'},{k:'assay',l:'Assay'},{k:'oz',l:'Serving'},{k:'e',l:'EPA'+uLbl},{k:'d',l:'DHA'+uLbl},{k:'a',l:'ALA'+uLbl},{k:'t',l:'Total'+uLbl},{k:'mp',l:'MP'}].forEach(c=>{
      h+='<th onclick="omSort(\''+c.k+'\')">'+c.l+(sortK===c.k?(sortA?' ▲':' ▼'):' ⇅')+'</th>';
    });
    h+='</tr></thead><tbody>';
    const fmtCell=v=>v==null?'<span style="color:#bbb">—</span>':v.toLocaleString();
    rows.forEach(r=>{
      const servTxt=basis==='100g'?'100g':r.oz+' oz';
      const isMP=r.assay==='Microplastics';
      const mpCell=r.mp?'<span title="0 of 6 polymers detected · LOD 1 microparticle" style="background:#2e8b57;color:#fff;font-size:10px;font-weight:700;padding:1px 6px;border-radius:3px">0 / 6</span>':'<span style="color:#bbb">—</span>';
      const assayCell=isMP?'<span style="background:rgba(99,102,241,0.12);color:#4338ca;font-size:10px;font-weight:600;padding:1px 6px;border-radius:3px">Microplastics</span>':'Fatty Acids';
      const rowStyle=isMP?' style="background:rgba(99,102,241,0.03)"':'';
      h+='<tr'+rowStyle+'><td><strong>'+r.s+'</strong></td><td style="color:var(--ce)">'+r.f+'</td><td>'+r.c+'</td><td>'+r.src+'</td><td>'+assayCell+'</td><td>'+servTxt+'</td>'
        +'<td class="n">'+fmtCell(r.e)+'</td><td class="n">'+fmtCell(r.d)+'</td><td class="n">'+fmtCell(r.a)+'</td>'
        +'<td class="n" style="font-weight:700">'+fmtCell(r.t)+'</td><td class="n">'+mpCell+'</td></tr>';
    });
    h+='</tbody></table>';
    document.getElementById('om-table').innerHTML=h;
  }

  function render(){renderChart();renderTable();}

  window.omMode=function(m,btn){mode=m;openIdx=-1;btn.parentElement.querySelectorAll('button').forEach(b=>b.classList.remove('active'));btn.classList.add('active');render();};
  window.omBasis=function(b,btn){basis=b;openIdx=-1;btn.parentElement.querySelectorAll('button').forEach(x=>x.classList.remove('active'));btn.classList.add('active');render();};
  window.omDet=function(i){document.querySelectorAll('.om-det.open').forEach(d=>d.classList.remove('open'));if(openIdx===i){openIdx=-1;return;}openIdx=i;var el=document.getElementById('om-d-'+i);if(el)el.classList.add('open');};
  window.omTab=function(v,btn){view=v;btn.parentElement.querySelectorAll('.om-tab').forEach(b=>b.classList.remove('active'));btn.classList.add('active');document.getElementById('om-chart').style.display=v==='chart'?'':'none';document.getElementById('om-table').style.display=v==='table'?'':'none';};
  window.omSort=function(k){if(sortK===k)sortA=!sortA;else{sortK=k;sortA=k==='s'||k==='f';}renderTable();};
  render();
})();

  } catch(e) { console.error(e); }
})();
})();
